



   
 
    document.addEventListener('DOMContentLoaded', () => {
      const questions = document.querySelectorAll('.question');
      console.log('Found questions:', questions.length); // Debug: Check if elements are found

      // Function to update dynamic max-height
      const updateContentHeight = (answer) => {
        answer.style.setProperty('--content-height', `${answer.scrollHeight + 40}px`); // Recalculate on demand
      };

      questions.forEach(question => {
        const parent = question.parentElement;
        const answer = parent.querySelector('.answer');
        updateContentHeight(answer); // Initial calculation

        // Click event to toggle accordion
        question.addEventListener('click', () => {
          console.log('Clicked question:', question); // Debug: Confirm click
          const isActive = parent.classList.contains('active');
          
          // Close other open accordions
          document.querySelectorAll('.step-section').forEach(section => {
            if (section !== parent) {
              section.classList.remove('active');
              section.querySelector('.question').setAttribute('aria-expanded', 'false');
            }
          });
          
          if (!isActive) {
            // Opening the section
            updateContentHeight(answer);
            parent.classList.add('active');
            question.setAttribute('aria-expanded', 'true');
            
            // Define the scroll function
            let timeoutId;
            const scrollAfterTransition = () => {
              if (timeoutId) clearTimeout(timeoutId);
              
              // Detect sticky header (customize selectors if needed for your Shopify theme)
              const possibleHeaders = ['header.site-header', '#shopify-section-header', 'header', '.header-wrapper', '.sticky-header'];
              let header = null;
              for (const selector of possibleHeaders) {
                header = document.querySelector(selector);
                if (header) break;
              }
              
              let headerHeight = 0;
              if (header) {
                headerHeight = header.getBoundingClientRect().height;
              } else {
                console.warn('Sticky header not found; no offset applied. Update selectors if needed.');
              }
              
              // Extra offset for small screens if header shrinks (adjust as needed)
              const extraOffset = window.innerWidth <= 768 ? 10 : 40;
              
              const questionRect = question.getBoundingClientRect();
              const viewportHeight = window.innerHeight;
              
              // Always scroll to align question below header
              const targetTop = window.scrollY + questionRect.top - headerHeight - extraOffset;
              window.scrollTo({ top: targetTop, behavior: 'smooth' });
            };
            
            // Listen for transitionend
            answer.addEventListener('transitionend', scrollAfterTransition, { once: true });
            
            // Fallback timeout
            timeoutId = setTimeout(scrollAfterTransition, 350); // Slightly longer than transition duration
          } else {
            // Closing the section
            parent.classList.remove('active');
            question.setAttribute('aria-expanded', 'false');
          }
        });

        // Keyboard support for accessibility
        question.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            question.click();
          }
        });
      });
    });
 

